import { render } from "./CollapseItemComp.vue?vue&type=template&id=7d123db4"
import script from "./CollapseItemComp.vue?vue&type=script&lang=js"
export * from "./CollapseItemComp.vue?vue&type=script&lang=js"

import "./CollapseItemComp.vue?vue&type=style&index=0&id=7d123db4&lang=css"

import exportComponent from "C:\\Users\\stage\\NetttFormApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__